import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getReferralPoint} from '../../../apis/point/getReferralPoint'

const PAGE_SIZE = 10

const useQueryGetPoint = (currentPage: number = 1) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.point.getReferralPoint(currentPage, PAGE_SIZE),
        queryFn: async () => {
            const {data, pageInfo} = await getReferralPoint(currentPage, PAGE_SIZE)
            return {data, pageInfo}
        },
    })

    return {data: data?.data, pageInfo: data?.pageInfo, refetch}
}

export default useQueryGetPoint
